<template>
  <div class="Dashboard">
    <div class="Dashboard__buttons-wrapper">
      <div>
        <v-btn color="primary" @click="callHandler" :disabled="adStatus">
          Call Selected
        </v-btn>
        <v-btn
          color="success ml-2"
          @click="autoDiallerHandler"
          v-if="adStatus == false"
        >
          Start AutoDialler
        </v-btn>
        <v-btn color="red ml-2 white--text" @click="autoDiallerHandler" v-else>
          Stop AutoDialler
        </v-btn>
      </div>
    </div>
    <section :class="`lead-table ${theme.isDark ? 'lead-table_dark' : null}`">
      <b-table
        :data="leads"
        :columns="columns"
        :per-page="perPage"
        :current-page.sync="numberPage"
        :paginated="isPaginated"
        :pagination-simple="isPaginationSimple"
        :pagination-position="paginationPosition"
        :checked-rows.sync="checkedRows"
        :row-class="rowClassHandler"
        checkable
        :checkbox-position="checkboxPosition"
      >
        <template slot="bottom-left">
          <b>Total checked</b>: {{ checkedRows.length }}
        </template>
      </b-table>
    </section>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import { Device } from "twilio-client";

export default {
  name: "AllLeadsTable",
  inject: ["theme"],
  data() {
    return {
      audio: null,
      soundurl: "../../../../public/audio/1.mp3",
      autoDiallerHandlerStatus: false,
      perPage: 10,
      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: "bottom",
      checkboxPosition: "left",
      checkedRows: [],
      columns: [
        {
          field: "source_title",
          label: "Source",
          searchable: true,
          sortable: true,
        },
        {
          field: "status_title",
          label: "Status",
          searchable: true,
          sortable: true,
        },
        {
          field: "fullname",
          label: "Full Name",
          searchable: true,
          sortable: true,
        },
        {
          field: "email",
          label: "Email",
          searchable: true,
          sortable: true,
        },
        {
          field: "phone",
          label: "Phone",
          searchable: true,
          sortable: true,
        },
        {
          field: "state_title",
          label: "State",
          searchable: true,
          sortable: true,
        },
        {
          field: "updated",
          label: "Last Change",
          searchable: true,
          sortable: true,
        },
      ],
    };
  },
  methods: {
    ...mapMutations({
      SET_CURRENT_PAGE: "leads/SET_CURRENT_PAGE",
      SET_ADSTATUS: "autodialer/SET_ADSTATUS",
    }),
    ...mapActions({
      loadGuideLeads: "leads/loadGuideLeads",
      showHandlerSnackbar: "snackbar/showHandlerSnackbar",
      loadAdStatus: "autodialer/loadAdStatus",
      switchStatus: "autodialer/switchStatus",
      startAutoDiallerOneByOne: "autodialer/startAutoDiallerOneByOne",
      setAudio: "autodialer/setAudio",
      disableAudio: "autodialer/disableAudio",
    }),

    rowClassHandler(row) {
      switch (row.AD_status) {
        case 1:
          return "is-blue";        
        case 2:
          return "is-red";
        case 3:
          return "is-orange";
        case 4:
          return "is-green";
        case 5:
          return "is-yellow";
        default:
          return;
      }
    },

    callHandler() {
      if (this.checkedRows.length == 0) {
        this.showHandlerSnackbar({
          color: "red",
          text: "Please select one or more leads",
          show: true,
        });
      } else {
        this.$axios
          .post("/twilio/call/selected", {
            leads: this.checkedRows,
          })
          .then((res) => {
            this.showHandlerSnackbar({
              color: res.data.status,
              text: res.data.message,
              show: true,
            });
          })
          .catch((err) => console.log(err));
      }
    },
    autoDiallerHandler() {      
      this.SET_ADSTATUS(!this.adStatus);
      this.switchStatus(this.user.id);
      if(this.adStatus){
        setTimeout(() => {
          this.startAutoDiallerOneByOne(this.user.id);
        }, 1000)
      } else {
        this.disableAudio();
      }
    },
  },
  mounted() {
    this.sockets.subscribe("CREATE_LEAD", () => {});
    this.sockets.subscribe("UPDATE_LEADS", () => {});
    this.sockets.subscribe("DELETE_LEAD", () => {});
    this.sockets.subscribe("RESTART_AD", () => {
      this.startAutoDiallerOneByOne(this.user.id);
    });
    this.loadGuideLeads();
    this.loadAdStatus(this.user.id);

    this.$axios
      .post("/call/token/" + this.user.id)
      .then((res) => {
        Device.setup(res.data.token, { debug: true, dscp: true });
      })
      .catch((err) => {
        console.log(err);
      });

    this.setAudio("../../../../audio/1.mp3");

    Device.on("disconnect", () => {
      this.$router.replace("/guide/leads");
      setTimeout(() => {
        this.startAutoDiallerOneByOne(this.user.id);        
      }, 1000);
    });

    Device.incoming(() => {
      this.disableAudio();
    });

    window.addEventListener("beforeunload", () => {
      this.SET_ADSTATUS(false);
      this.switchStatus(this.user.id);
    });
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      leads: "leads/leads",
      loadingLeads: "leads/loadingLeads",
      currentPage: "leads/currentPage",
      adStatus: "autodialer/adStatus",
    }),
    numberPage: {
      get: function () {
        return this.currentPage;
      },
      set: function (number) {
        this.SET_CURRENT_PAGE(number);
      },
    },
  },
};
</script>
